import {
  Avatar,
  CellHeader,
  CellList,
  CellSimple,
} from "@maxhub/max-ui"

const AVATARS = [
  "https://sun9-67.userapi.com/s/v1/ig2/JsDOGxKlelRtyPp3DgWYYxPbSMfsENZjZdWiDANWbV7MEmsJjdIivjgHhWTH5JlNJCJVX-KBKhIYahjkbjzvxxhD.jpg?quality=95&crop=344,13,854,854&as=32x32,48x48,72x72,108x108,160x160,240x240,360x360,480x480,540x540,640x640,720x720&ava=1&cs=100x100",
  "https://sun9-67.userapi.com/s/v1/ig2/CY_xDesKnMtl0OiJynK0oc7QnxQVJUgeciJSi_MpZUiE3EHSCNltr76jugXaygGd2Xh0M8-61v7Jwfl1kO87YWVe.jpg?quality=95&crop=0,0,1440,1440&as=32x32,48x48,72x72,108x108,160x160,240x240,360x360,480x480,540x540,640x640,720x720,1080x1080,1280x1280,1440x1440&ava=1&u=SpmuDKJYdLKKRYYDgjLVQdEn6QnBonR3kSYxCSkCnm4&cs=200x200",
  "https://sun9-22.userapi.com/s/v1/ig2/GIx9ixLIVcH_Cu_E5hwjYXqHSDGEO6XkE33wfKgVvs1c33VaMO24otPJ_nrgWHt7dOP1B3kWEYxoIezkFxu9ygxZ.jpg?quality=95&crop=100,579,1010,1010&as=32x32,48x48,72x72,108x108,160x160,240x240,360x360,480x480,540x540,640x640,720x720&ava=1&cs=100x100",
]

const USERS = ["Igor Foxik", "Vadim Tregubenko", "Ira Grishina"]

export const CellListExample = {
  title: "CellList",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [
    {
      name: "mode",
      label: "mode",
      type: "enum",
      tsType: ['"full-width"', '"island"'],
      default: "island",
      options: ["full-width", "island"],
    },
    {
      name: "filled",
      label: "filled",
      type: "boolean",
      tsType: "boolean",
      default: true,
    },
    {
      name: "header",
      label: "header",
      type: "select",
      tsType: "ReactNode",
      default: "none",
      options: [
        { value: "none", label: "None" },
        { value: "yes", label: "Yes" },
      ],
    },
  ],

  Preview({ props }) {
    return (
      <CellList
        filled={props.filled}
        header={
          props.header === "yes" ? (
            <CellHeader titleStyle="caps">Пользователи</CellHeader>
          ) : undefined
        }
        mode={props.mode}
      >
        {USERS.map((name, i) => (
          <CellSimple
            key={i}
            before={
              <Avatar.Container size={40}>
                <Avatar.Image src={AVATARS[i]} />
              </Avatar.Container>
            }
            onClick={() => {}}
            showChevron
            title={name}
          />
        ))}
      </CellList>
    )
  },

  getCode(props) {
    const listProps = []
    listProps.push("  filled")
    if (props.mode !== "island") listProps.push(`  mode="${props.mode}"`)
    if (props.header === "yes")
      listProps.push(`  header={<CellHeader titleStyle="caps">Пользователи</CellHeader>}`)

    const listPropsStr = listProps.length > 0 ? "\n" + listProps.join("\n") + "\n" : ""
    return `<CellList${listPropsStr}>
  <CellSimple
    before={<Avatar.Container size={40}><Avatar.Image src="…" /></Avatar.Container>}
    onClick={() => {}}
    showChevron
    title="Igor Foxik"
  />
  <CellSimple
    before={<Avatar.Container size={40}><Avatar.Image src="…" /></Avatar.Container>}
    onClick={() => {}}
    showChevron
    title="Vadim Tregubenko"
  />
  <CellSimple
    before={<Avatar.Container size={40}><Avatar.Image src="…" /></Avatar.Container>}
    onClick={() => {}}
    showChevron
    title="Ira Grishina"
  />
</CellList>`
  },
}